var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mt-2 mb-4"},[_vm._v("Precios"),_c('List',{ref:"list",on:{"openEditDialog":_vm.openEditDialog}})],1),_c('PreciosForm',{ref:"preciosForm",on:{"reloadData":_vm.reloadData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }